import { CarePlan, PatientCarePlanControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientCareplanCreate = () =>
  useMutationWithLoading(
    async (params: { carePlan: CarePlan; xTENANTID?: string }) =>
      new PatientCarePlanControllerApi(getConfigObject()).createCarePlan(
        params.carePlan,
        params.xTENANTID
      )
  );
